import Home from '@/components/pages/Home'
import OurServices from '@/components/pages/OurServices'
import ContactUs from '@/components/pages/ContactUs'
import WhyUseUs from '@/components/pages/WhyUseUs'
import Testimonials from '@/components/pages/Testimonials'
import Privacy from '@/components/pages/Privacy'
import Terms from '@/components/pages/Terms'

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/our-services/',
    name: 'OurServices',
    component: OurServices,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/contact-us/',
    name: 'ContactUs',
    component: ContactUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/why-use-us/',
    name: 'WhyUseUs',
    component: WhyUseUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/testimonials/',
    name: 'Testimonials',
    component: Testimonials,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/privacy-policy/',
    name: 'Privacy',
    component: Privacy,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/terms-and-conditions/',
    name: 'Terms',
    component: Terms,
    pathToRegexpOptions: { strict: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js